import type { Component } from 'vue'

export interface DrawerState {
  id: string
  content: Component
}

export const useLayoutApp = () => {
  const drawerState = useState<DrawerState | null>(() => null)

  const openDrawer = ({ content, ...rest }: DrawerState) => {
    drawerState.value = {
      ...rest,
      content: markRaw(content)
    }
  }

  const closeDrawer = () => {
    drawerState.value = null
  }

  return {
    drawerState: readonly(drawerState),
    openDrawer,
    closeDrawer
  }
}
